export const REST_API = window.location.origin + "/api";
